import { Modal } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import DeleteWarningModalWithAction from '../../../../components/Common/DeleteWarningModalWithAction';
import {
  getUSDValue,
  updatePromoCode
} from '../../../../services/promoCodeService';
import PromoCodeForm from './PromoCodeForm';
const PromoCodeEdit = ({
  promoCode,
  id,
  status,
  setStatus,
  isOpen,
  toggle,
  courses,
  courseOffers
}) => {
  const initialValues = {
    ...promoCode,
    startDate: moment(promoCode.startDate),
    endDate: moment(promoCode.endDate)
  };
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(
    false
  );
  const [promoFormValues, setpromoFormValues] = useState(false);

  const getDiscountValue = (value, type) => {
    return type === 'amount_off' ? getUSDValue(value) : parseInt(value);
  };

  const onConfirm = async () => {
    let payload = {
      ...promoFormValues,
      startDate: promoFormValues.startDate.utc().format(),
      endDate: promoFormValues.endDate.utc().format(),
      metadata: promoCode.metadata
    };

    delete payload.referrerId;

    await updatePromoCode(payload, id)
      .then((response) => {
        setStatus({
          type: 'SUCCESS',
          message: 'Promo code added successfully!'
        });
      })
      .catch((error) => {
        alert('Posting data to the backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  const onSubmit = async (payload) => {
    setIsConfirmModalVisible(true);
    if (payload.discountType === 'amount_off') {
      payload.discountValue = parseInt(payload.discountValue * 100);
    }
    for (let countryDiscount of payload.countryWiseDiscounts) {
      countryDiscount.value =
        payload.discountType === 'amount_off'
          ? countryDiscount.value * 100
          : countryDiscount.value;
    }
    setpromoFormValues(payload);
  };

  return (
    <Modal
      title={`Update Discount Code`}
      visible={isOpen}
      onCancel={() => toggle()}
      footer={null}>
      <PromoCodeForm
        type="Update"
        initialValues={initialValues}
        onSubmit={onSubmit}
        status={status}
        visible={isOpen}
        setStatus={setStatus}
        courseOffers={courseOffers}
        courses={courses}
        maxValue={
          initialValues.discountType === 'percent_off'
            ? 100
            : Number.MAX_SAFE_INTEGER
        }
      />
      <DeleteWarningModalWithAction
        isVisible={isConfirmModalVisible}
        setIsVisible={setIsConfirmModalVisible}
        action={onConfirm}
        question={`Are You Sure You Want To Edit ${
          initialValues.isCorporate ? 'Corporate ' : ''
        } ${promoFormValues.type} ${
          promoFormValues.code
        } with ${getDiscountValue(
          promoFormValues.discountValue,
          promoFormValues.discountType
        )} ${
          promoFormValues.discountType === 'percent_off' ? '%' : 'USD'
        } off ${
          initialValues.isCorporate && !promoFormValues.isCorporate
            ? 'and Make it non-Corporate'
            : !initialValues.isCorporate && promoFormValues.isCorporate
            ? 'and Make it Corporate'
            : ''
        }?`}
        buttonLabel="Confirm"
      />
    </Modal>
  );
};

export default PromoCodeEdit;
